import { FilterItem } from "../../../../../../../dashboard/reports/components/table/utils/styled";
import FormControl from "@mui/material/FormControl";
import { InputLabel, NativeSelect } from "../../../../../../../../common/styles/muiStyled";
import React from "react";
import { FilterProps } from "../../../../../../types";
import { SelectChangeEvent } from "@mui/material/Select";
import { useTranslation } from "react-i18next";

type Props = Omit<FilterProps, "config" | 'filterTableData'>;

export const PaymentStatusFilter = ({ filterSetters, filterGetters }: Props) => {
  const { t } = useTranslation('common');

  const onChange = (e: SelectChangeEvent) => {
    filterSetters.onBadgePaymentStatusFilterChange(e.target.value);
  }

  return (
    <FilterItem>
      <FormControl fullWidth>
        <InputLabel>{t('companyPage.table.paymentStatus')}</InputLabel>
        <NativeSelect value={filterGetters.selectedBadgePaymentStatus} onChange={onChange}>
          {filterGetters.paymentStatusOptions.map(row => <option value={row.status} key={row.status}>{row.label}</option>)}
        </NativeSelect>
      </FormControl>
    </FilterItem>
  );
};
